import objectPath from "object-path";

export function getProfileLabel(profile) {
    return objectPath.get(profile, "jobFunctions.value.0.labels.0", "<no label found>");
}

export function getProfileDisplayId(profile) {
    return objectPath.get(profile, "jobFunctions.value.0.conceptIds.0", "<no ID found>");
}
